import { useState } from "react";
import { Link } from "react-router-dom";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { castIcon } from "../utils/castIcon";

const MenuIcon = castIcon(HiMenuAlt3);
const CloseIcon = castIcon(HiX);

const PublicHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="bg-white shadow-md sticky top-0 z-50 w-full">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
                {/* Logo */}
                <Link to="/" className="flex items-center space-x-2">
                    <img src="/logo.png" alt="Logo" className="h-8 w-8" />
                    <span className="text-2xl font-bold text-blue-600">SavoryBot</span>
                </Link>
                <nav className="hidden md:flex items-center space-x-6">
                    <Link to="/" className="text-gray-700 hover:text-blue-600 transition">Home</Link>
                    <Link to="/pricing" className="text-gray-700 hover:text-blue-600 transition">Pricing</Link>
                    <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition">Contact</Link>
                    <Link
                        to="/login"
                        className="ml-4 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition"
                    >
                        Login
                    </Link>
                </nav>
                <button
                    className="md:hidden text-gray-700 focus:outline-none"
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    {menuOpen ? <CloseIcon className="w-7 h-7" /> : <MenuIcon className="w-7 h-7" />}
                </button>
            </div>
            {menuOpen && (
                <div className="md:hidden bg-white px-6 pb-4">
                    <nav className="space-y-3">
                        <Link to="/" onClick={() => setMenuOpen(false)} className="block text-gray-700 hover:text-blue-600">Home</Link>
                        <Link to="/pricing" onClick={() => setMenuOpen(false)} className="block text-gray-700 hover:text-blue-600">Pricing</Link>
                        <Link to="/contact" onClick={() => setMenuOpen(false)} className="block text-gray-700 hover:text-blue-600">Contact</Link>
                        <Link
                            to="/login"
                            onClick={() => setMenuOpen(false)}
                            className="block text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md"
                        >
                            Login
                        </Link>
                    </nav>
                </div>
            )}
        </header>
    );
};

export default PublicHeader;
